/* src/app/auth/components/recover-confirm/recover-confirm.component.scss */
form {
  width: 400px;
  max-width: 100%;
}
/*# sourceMappingURL=recover-confirm.component.css.map */
